import { clearAllErrors, clearError } from "../../actions/errorActions";
import { RootState, useAppDispatch, useAppSelector } from "../../store";
import { DisclaimerHtml } from "./miscComponents";
import { DEFAULT_ERROR_MESSAGE } from '../constants/errorMessage';

function ActiveErrors() {

    const dispatch = useAppDispatch();
    const activeErrors = useAppSelector((state: RootState) => state.apiErrors.activeErrors);
    const errorMessageOverride = useAppSelector((state: RootState) => state.config.instance.errorMessageOverride)

    const dismiss = (e: any, actionId: string) => {
        e.preventDefault();
        dispatch(clearError(actionId));
    }

    const dismissAll = () => {
        dispatch(clearAllErrors());
    }

    let className = errorMessageOverride ? "page-error" : "page-error default"
    let error = (activeErrors && activeErrors.length > 0) ?
        <DisclaimerHtml
            className={className}
            text={errorMessageOverride || DEFAULT_ERROR_MESSAGE}
            isVisible={true}
        />
        : null;
    return error;
}

export default ActiveErrors;